/* eslint-disable react/style-prop-object */
import React , { useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import Bg from '../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../images/shapes/shape_line_2.svg'
import shape2 from '../../images/shapes/shape_line_3.svg'
import shape3 from '../../images/shapes/shape_line_4.svg'
import shape4 from '../../images/shapes/shape_space_3.svg'
import wImg from '../../images/about/Frame-x.png'
import sIcon1 from '../../images/kodo/icons2/Group 1000003603.svg'
import sIcon2 from '../../images/kodo/icons2/Group 1000003604.svg'
import sIcon3 from '../../images/kodo/icons2/Group 1000003605.svg'
import sIcon4 from '../../images/kodo/icons2/Group 1000003611.svg'
import sIcon5 from '../../images/kodo/icons2/Group 1000003612.svg'
import sIcon6 from '../../images/kodo/icons2/Group 1000003613.svg'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import WhyUs from '../../main-component/AboutUsPage/WhyUs';
import FaqSection from '../software-company-components/FaqSection/FaqSection';
import ContactSection from '../software-company-components/ContactSection/index';
import TeamSection from '../../components/TeamSection/TeamSection';

const ProjectSection = (props) => {

    const Policy = [
        {
            title: 'Guaranteed Placement',
            icon: sIcon5,
        
        },
        {
            title: 'Career Networking',
            icon: sIcon2,
        },
        {
            title: 'Global Exposure',
            icon: sIcon3,
        },
        {
            title: 'Corporate Environment',
            icon: sIcon4,
        },
      
        {
             title: 'Deep Industry Alignment',
            icon: sIcon1,
        },
        {
            title: 'Real-World Projects',
            icon: sIcon6,
        }
    
    ]
    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    const faqData = [
        { question: 'Q. What is the duration of the Kodo Program?', answer: '6 months, with blended learning held at Hanudev InfoPark, Coimbatore, with batches starting every 3 months.' },
        { question: 'Q. Who is eligible to join the program?', answer: 'Beginners, freshers, career-switchers, or those on breaks seeking AI/ML roles; no strict prior experience needed.' },
        { question: 'Q. What is the fee structure for the program?', answer: 'The fee covers the full 6-month program, including training, resources, and support, with details available on application.' },
        { question: 'Q. What are the benefits of joining the program?', answer: 'Gain AI/ML skills, job readiness (15 LPA+ potential), real projects, mentorship, certification, and guaranteed placement.' },
        { question: 'Q. Are there any prerequisites for joining the program?', answer: 'Visit www.xnovaq.com/kodo-program and fill out the enrollment form for details and next steps.' },
        { question: 'Q. What does the guaranteed placement entail?', answer: 'Guaranteed placement is offered to top performers, ensuring a job upon completing the program based on their excellence.' },

        { question: 'Q. Is there an internship after the 6-month course?', answer: 'Yes, a 6-month internship follows the course, with a job offered if performance is strong during the internship.' }
    ];

    return (
        <section className="process_technology_review_section  section_decoration" style={{ backgroundColor : '#dffdee' }}>
        <div className="container">
            <div className="row align-items-center justify-content-lg-between">
                <div className="col-lg-6">
                    <div className="heading_block">
                        <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                            Working Process
                        </div>
                        <h2 className="heading_text mb-0">
                        Start Your<span  style={{color: "#1DBF73"}}> Learning and Career Journey With Us</span >
                        </h2>
                    </div>
                    <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="1">
                                1. Online Registration
                            </AccordionHeader>
                            <AccordionBody accordionId="1" className='acc_body'>
                                <p className="m-0">
                                    Visit our website and fill out the online registration form.

                                </p>
                                <p>
                                Provide your basic information and express your interest in joining Kodo Program.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="2">
                                2. Schedule an Appointment
                            </AccordionHeader>
                            <AccordionBody accordionId="2" className='acc_body'>
                                <p className="m-0">
                                Our Business Manager will contact you to schedule a convenient time for an in-person meeting at our Hanudev InfoPark, Coimbatore.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="3">
                                3. Initial Assessment
                            </AccordionHeader>
                            <AccordionBody accordionId="3" className='acc_body'>
                                <p className="m-0">
                                Attend an initial assessment session to evaluate your suitability for the program.
                                </p>
                                <p>
                                This assessment will assess your technical aptitude, communication skills, and overall fit for the program.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="4">
                                4. Enrollment
                            </AccordionHeader>
                            <AccordionBody accordionId="4" className='acc_body'>
                                <p className="m-0">
                                Based on the assessment results, you will be guided through the enrollment process.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="5">
                                5. Kickstart Your AI Journey
                            </AccordionHeader>
                            <AccordionBody accordionId="5" className='acc_body'>
                                <p className="m-0">
                                Begin your journey towards becoming a skilled IT professional.
                                </p>
                                <p>
                                Learn from experienced instructors, work on real-world projects, and gain valuable hands-on experience.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
                <div className="col-lg-5">
                    <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                        <ul className="content_layer_group1 unordered_list_block text-center">
                            <li><AccordionHeader targetId="1"><span>Online Registration</span></AccordionHeader></li>
                            <li><AccordionHeader targetId="2"><span>Schedule an Appointment</span></AccordionHeader></li>
                            <li><AccordionHeader targetId="3"><span>Initial Assessment</span></AccordionHeader></li>
                            <li><AccordionHeader targetId="4"><span>Enrollment</span></AccordionHeader></li>
                            <li><AccordionHeader targetId="5"><span>Kickstart Your Learning Journey</span></AccordionHeader></li>
                        </ul>
                    </Accordion>
                </div>
            </div>
            {/* <TechnologySection/> */}
            {/* <Testimonial/> */}
        </div>

        <div className="decoration_item shape_image_1">
            <img src={shape1} alt="Techco Shape" className='kodo-img' />
        </div>
        <div className="decoration_item shape_image_2">
            <img src={shape2} alt="Techco Shape" className='kodo-img'/>
        </div>
        <div className="decoration_item shape_image_3">
            <img src={shape3} alt="Techco Shape" className='kodo-img'/>
        </div>
        <div className="decoration_item shape_image_4">
            <img src={shape4} alt="Techco Shape" className='kodo-img'/>
        </div>
       <WhyUs policies={Policy} img={wImg} title="Why Us" style={'pb-0'} subtitle="Why Kodo over a Training Institute?" />
       <TeamSection />
       <FaqSection 
                title="F.A.Q." 
                subtitle="Kodo Program FAQs" 
                faqs={faqData} 
            />
       <ContactSection/>
    </section>
 
        // <section className="portfolio_section xb-hidden section_space pb-0">
        //     <div className="container">
        //         <div className="heading_block">
        //             <div className="row align-items-end">
        //                 <div className="col-lg-7">
        //                     <div className="heading_focus_text">
        //                         <span className="badge bg-secondary text-white">Crafting</span>
        //                         Success With 😍 Project
        //                     </div>
        //                     <h2 className="heading_text">
        //                         Our Recent Best Works
        //                     </h2>
        //                     <p className="heading_description mb-0">
        //                         Our recent projects highlight our expertise in delivering tailored solutions that meet the unique needs and objectives of our clients,custom software.
        //                     </p>
        //                 </div>
        //                 <div className="col-lg-5 d-none d-lg-flex justify-content-end">
        //                     <Link onClick={ClickHandler} to={'/portfolio'} className="btn btn-primary">
        //                         <span className="btn_label" data-text="All Works">All Works</span>
        //                         <span className="btn_icon">
        //                             <i className="fa-solid fa-arrow-up-right"></i>
        //                         </span>
        //                     </Link>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        //     <div className="portfolio_carousel">
        //         <Swiper
        //             // install Swiper modules
        //             modules={[Pagination, A11y]}
        //             slidesPerView={1}
        //             loop={true}
        //             spaceBetween= {30}
        //             allowTouchMove= {true}
        //             centeredSlides= {true}
        //             pagination={{ clickable: true }}
        //             speed={400}
        //             parallax={true}
        //             breakpoints={{
        //                 1025: {
        //                     slidesPerView: 2,
        //                 },
        //             }}
        //         >

        //             {Project.slice(0, 5).map((project, prj) => (
        //                 <SwiperSlide key={prj}>
        //                     <div className="portfolio_block" >
        //                         <div className="portfolio_image">
        //                             <Link onClick={ClickHandler} className="portfolio_image_wrap bg-light" to={`/portfolio_details/${project.slug}`}>
        //                                 <img src={project.pImg} alt="Mobile App Design" />
        //                             </Link>
        //                         </div>
        //                         <div className="portfolio_content">
        //                             <h3 className="portfolio_title">
        //                                 <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}>
        //                                     {project.title}
        //                                 </Link>
        //                             </h3>
        //                             <ul className="category_list unordered_list">
        //                                 <li><Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}>{project.sub}</Link></li>
        //                             </ul>
        //                             <Link onClick={ClickHandler} className="btn btn-outline-light" to={`/portfolio_details/${project.slug}`}>
        //                                 <span className="btn_label" data-text="Explore">Explore</span>
        //                                 <span className="btn_icon">
        //                                     <i className="fa-solid fa-arrow-up-right"></i>
        //                                 </span>
        //                             </Link>
        //                         </div>
        //                     </div>
        //                 </SwiperSlide>
        //             ))}
        //         </Swiper>
        //     </div>
        //     <div className="container text-center d-block d-lg-none">
        //         <div className="btns_group pb-0">
        //             <Link onClick={ClickHandler} className="btn btn-primary" to="/pricing">
        //                 <span className="btn_label" data-text="All Works">All Works</span>
        //                 <span className="btn_icon">
        //                     <i className="fa-solid fa-arrow-up-right"></i>
        //                 </span>
        //             </Link>
        //         </div>
        //     </div>
        // </section>
    );
}

export default ProjectSection;